class BlogSearch {
	constructor() {
		this.searchInput = document.getElementById("js-blog-search-input");
		this.articlesContainer = document.querySelector(".js-blog-articles");
		this.spinner = document.getElementById("loading-spinner");
		this.currentCategoryTag = (this.articlesContainer && this.articlesContainer.dataset.currentCategory) ? this.articlesContainer.dataset.currentCategory : '';
		const ds = this.articlesContainer ? this.articlesContainer.dataset : {};
		this.seGuidesTranslation = ds.readMore || '';
		this.noArticlesFoundTranslation = ds.noResults || '';
		this.articlesQty = ds.articlesCount || 0;
		this.searchTitle = ds.searchTitle || '';

		// Create a separate container for search results so the original DOM
		// (and its pagination event listeners) is never destroyed
		this.searchResultsContainer = document.createElement('div');
		this.searchResultsContainer.className = 'js-blog-search-results tw:rounded-[5px] tw:relative tw:mb-8 tw:hidden';
		if (this.articlesContainer) {
			this.searchResultsContainer.style.backgroundColor = this.articlesContainer.style.backgroundColor;
			this.articlesContainer.after(this.searchResultsContainer);
		}

		this.init();
	}

	init() {
		if (!this.searchInput || !this.articlesContainer) return;

		// Initial state: hide on category-all if input empty
		if (this.currentCategoryTag === 'category-all' && this.searchInput.value.trim() === "") {
			this.articlesContainer.classList.add("tw:hidden");
		}

		this.searchInput.addEventListener("input", () => {
			if (this.searchInput.value.trim() === "") {
				// Hide search results and clear them
				this.searchResultsContainer.classList.add("tw:hidden");
				this.searchResultsContainer.innerHTML = '';

				if (this.currentCategoryTag === 'category-all') {
					this.articlesContainer.classList.add("tw:hidden");
				} else {
					// Show original articles - DOM was never destroyed, pagination still works
					this.articlesContainer.classList.remove("tw:hidden");
				}
				return;
			}

			clearTimeout(this.debounceTimeout);
			this.debounceTimeout = setTimeout(() => {
				this.performSearch();
			}, 300);
		});
	}

	// Perform search and handle pagination to fetch all results
	async performSearch() {
		const query = this.searchInput.value.trim();
		if (query.length < 2) return;
	
		this.spinner.classList.remove("tw:hidden");

		try {
			const allArticles = [];
			let offset = 0;
			const limit = 10; // Shopify API limit per request
			const maxResults = this.articlesQty; // Max results we want to fetch
			let hasMoreResults = true;

			while (hasMoreResults) {
				if (allArticles.length >= maxResults) {
					break;
				}
	
				const response = await fetch(
					`/search/suggest.json?q=${encodeURIComponent(
						query
					)}&resources[type]=article&resources[limit]=${limit}&resources[offset]=${offset}`
				);
				const data = await response.json();
				const articles = data.resources.results.articles;
	
				if (articles.length < limit) {
					hasMoreResults = false;
				}
	
				allArticles.push(...articles);
	
				offset += limit;
	
				if (allArticles.length >= maxResults) {
					hasMoreResults = false;
				}
			}
	
			this.displayResults(allArticles);
		} catch (error) {
			console.error("Search error:", error);
		} finally {
			this.spinner.classList.add("tw:hidden");
		}
	}
	

	displayResults(articles) {
		const query = this.searchInput.value.trim();

		this.articlesContainer.classList.add("tw:hidden");

		let searchMessage = '';
		if (!articles || articles.length === 0) {
			searchMessage = `<p class="tw:p-4 tw:pb-2 tw:md:pb-4 tw:text-2xl tw:lg:text-3xl tw:font-semibold tw:w-full">${this.noArticlesFoundTranslation} "${query}"</p>`;
		} else {
			searchMessage = `<p class="tw:p-4 tw:pb-2 tw:md:pb-4 tw:text-2xl tw:lg:text-3xl tw:font-semibold tw:w-full">${this.searchTitle} "${query}"</p>`;
		}

		const resultsHtml = articles
			.map(
				(article) => `
				<div class="blog-articles__article article tw:relative tw:md:grid tw:md:row-span-5 tw:md:grid-rows-subgrid">
					<article class="article-card tw:flex tw:flex-col tw:md:grid tw:md:row-span-4 tw:md:grid-rows-subgrid tw:h-full tw:w-full tw:bg-white tw:border tw:border-pink-300 tw:rounded-[10px] tw:overflow-hidden">
						${article.image ? `
							<a href="${article.url}" class="tw:block tw:relative tw:overflow-hidden" style="padding-bottom: 56.25%;">
								<img src="${article.image}" alt="${article.title}" loading="lazy" class="tw:block tw:absolute tw:inset-0 tw:w-full tw:h-full tw:object-cover">
							</a>
						` : ""}
						<div class="tw:p-4 tw:flex tw:flex-col tw:md:grid tw:md:row-span-3 tw:md:grid-rows-subgrid tw:grow">
							<header>
								<h2 class="tw:text-xl tw:font-semibold tw:leading-tight tw:m-0 tw:mt-1 tw:line-clamp-2">
									<a href="${article.url}" class="tw:no-underline" style="color: inherit;">${article.title}</a>
								</h2>
							</header>
							<p class="tw:text-sm tw:mt-3 tw:mb-0 tw:leading-snug tw:line-clamp-3">
								${article.body ? article.body.replace(/<[^>]*>/g, '').split(' ').slice(0, 30).join(' ') : ""}
							</p>
							<div class="tw:mt-auto tw:pt-4">
								<a href="${article.url}" class="tw:button tw:button-pink tw:w-full tw:text-center tw:no-underline">${this.seGuidesTranslation}</a>
							</div>
						</div>
					</article>
				</div>
			`)
			.join("");

		this.searchResultsContainer.innerHTML = searchMessage +
			'<div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-3 tw:gap-4 tw:md:gap-y-0 tw:md:[grid-auto-rows:auto_auto_auto_auto_1rem] tw:w-full tw:p-4 tw:pt-0">' +
			resultsHtml +
			'</div>';
		this.searchResultsContainer.classList.remove("tw:hidden");
	}
}

document.addEventListener("DOMContentLoaded", () => {
	new BlogSearch();
});


